import { render, staticRenderFns } from "./MyDetailsChange.vue?vue&type=template&id=385f0749&scoped=true&"
import script from "./MyDetailsChange.vue?vue&type=script&lang=js&"
export * from "./MyDetailsChange.vue?vue&type=script&lang=js&"
import style0 from "./MyDetailsChange.vue?vue&type=style&index=0&id=385f0749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f0749",
  null
  
)

export default component.exports